(function () {
	// Normalisation simple du texte (on coupe avant " - " pour ignorer "En rupture de stock")
	function norm(txt) {
		if (!txt) return '';
		return String(txt).split(' - ')[0].trim().replace(/\s+/g, ' ');
	}

	function findCard(el) {
		return el.closest('.product-miniature') || el.closest('.card') || el.closest('.grid__item');
	}

	// Met le bouton quick add au diapason de la variante selectionnee.
	// Le Liquid rend toujours les deux libelles (.available-message / .sold-out-message) :
	// seule la classe `hidden` decide lequel s'affiche.
	function syncSubmit(card, available) {
		const submitButton = card.querySelector('product-form .quick-add__submit');
		if (!submitButton) return;

		// Pendant un ajout au panier (et apres une erreur d'ajout), product-form.js
		// pilote lui-meme le bouton : on ne lui passe pas dessus.
		if (submitButton.classList.contains('loading')) return;

		const variantInput = card.querySelector('product-form input.product-variant-id');
		if (variantInput) variantInput.disabled = !available;

		submitButton.disabled = !available;
		submitButton.setAttribute('aria-disabled', String(!available));

		const availableMessage = submitButton.querySelector('.available-message');
		const soldOutMessage = submitButton.querySelector('.sold-out-message');
		if (availableMessage) availableMessage.classList.toggle('hidden', !available);
		if (soldOutMessage) soldOutMessage.classList.toggle('hidden', available);
	}

	// Renvoie true si la carte porte bien un quick add a synchroniser.
	function syncCard(card, updateSubmit) {
		if (!card) return false;

		const hidden = card.querySelector('select.card__content-hidden-variant');
		if (!hidden) return false;

		// On récupère tous les selects complémentaires (option-1, option-2, ...)
		const selects = card.querySelectorAll('select.select_complementary_tdb');
		if (!selects.length) return false;

		// On construit les critères : { data-option-1: "valeur1", data-option-2: "valeur2" }
		const criteria = {};
		selects.forEach((sel) => {
			const match = Array.from(sel.classList).find((c) => c.startsWith('option-'));
			if (!match) return;
			const key = 'data-' + match; // => data-option-1
			const val = norm(sel.selectedOptions?.[0]?.textContent);
			if (val) criteria[key] = val;
		});

		// On cherche l’option cachée qui matche tous les data-option-N
		const match = Array.from(hidden.options).find((opt) =>
			Object.entries(criteria).every(([attr, val]) => norm(opt.getAttribute(attr)) === val)
		);

		if (match && hidden.value !== match.value) {
			hidden.value = match.value;
			const variantInput =
				card.querySelector('product-form input.product-variant-id') ||
				card.querySelector('input.product-variant-id');
			if (variantInput) variantInput.value = hidden.value;
		}

		// Combinaison inexistante : on bloque l'ajout.
		if (updateSubmit) {
			syncSubmit(card, match ? match.getAttribute('data-available') === 'true' : false);
		}

		return true;
	}

	function onChange(e) {
		const sel = e.target.closest('select.select_complementary_tdb');
		if (!sel) return;
		const card = findCard(sel);
		syncCard(card, true);
	}

	function syncAll() {
		document.querySelectorAll('.product-miniature, .card').forEach((card) => {
			// Le bouton n'est aligne qu'une fois par carte, au premier passage :
			// syncAll est rappele a chaque mutation du DOM et ecraserait sinon
			// l'etat pose par product-form.js pendant un ajout au panier.
			const first = !card.dataset.tdbQuickAddSynced;
			if (syncCard(card, first) && first) card.dataset.tdbQuickAddSynced = 'true';
		});
	}

	// Un seul listener global
	document.addEventListener('change', onChange, true);

	// Re-sync après le rendu ou les rechargements Shopify
	requestAnimationFrame(syncAll);
	document.addEventListener('shopify:section:load', syncAll);

	// Filet de sécurité : DOM modifié (ex : lazy loading)
	const mo = new MutationObserver(() => requestAnimationFrame(syncAll));
	mo.observe(document.documentElement, { childList: true, subtree: true });
})();
